import React, {Component} from 'react';
import {AppContext} from "../AppContext";

class Utils extends Component {


    static contextType = AppContext;

    //Błąd wysyłki pliku musi być widoczny dla użytkownika. Wcześniej catch tylko logował
    //do konsoli, więc nieudane wgranie wyglądało jak udane - stąd zgłoszenia o "znikających" zdjęciach.
    static getUploadErrorMessage(error) {
        const data = error && error.response ? error.response.data : null
        if (data && typeof data === 'object' && data.message) return data.message
        if (typeof data === 'string' && data.trim() !== '') return data
        //Spring Boot domyślnie nie przesyła treści błędu do przeglądarki, więc opisujemy po kodzie
        const status = error && error.response ? error.response.status : null
        if (status === 415) return 'Nie udało się przetworzyć zdjęcia - format nieobsługiwany lub plik uszkodzony. Wyślij je jako JPEG lub PNG.'
        if (status === 413) return 'Plik jest za duży.'
        if (status === 403) return 'Brak uprawnień do tej operacji.'
        if (status === 503) return 'Serwer jest zajęty. Spróbuj ponownie za chwilę.'
        if (status === 500) return 'Błąd serwera podczas przetwarzania pliku. Zgłoś problem administratorowi.'
        if (status !== null) return 'Serwer zwrócił błąd ' + status + '.'
        return 'Nie udało się połączyć z serwerem.'
    }

    static getExtensionFromFilename(filename) {
        var fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi
        return filename.match(fileExtensionPattern)[0];
    }

    static getServiceTypeFromEnumValue(enumValue) {
        if (enumValue === 'INSTALACJA') return 'INSTALACJA'
        if (enumValue === 'SZKOLENIE_OPERATOROW') return 'SZKOLENIE OPERATORÓW'
        if (enumValue === 'PRZEGLAD_OKRESOWY') return 'PRZEGLĄD OKRESOWY'
        if (enumValue === 'NAPRAWA') return 'NAPRAWA'
        if (enumValue === 'PROTOKOL_PRZEDMONTAZOWY') return 'PROTOKÓŁ PRZEDMONTAŻOWY'
        if (enumValue === 'MONTAZ') return 'PROTOKÓŁ MONTAŻU'
    }

    //Zamienia string z wartościami enum z DB na Array z nazwami pełnymi
    static getServiceTypesNamesAsArray(string){
        let array = JSON.parse(string.replace('[','["').replace(']','"]').replaceAll(',','","').replaceAll(" ", ""));
        console.log(array)
        return array.map(type => this.getServiceTypeFromEnumValue(type))
    }


    render() {
        return (
            <div>

            </div>
        );
    }
}

export default Utils;


